import React from "react";
import PropTypes from "prop-types";
import StarBorderBlackIcon from "./star_border_black_24dp.svg?react";
import StarBorderWhiteIcon from "./star_border_white_24dp.svg?react";

export default function StarBorderIcon(props) {
	return <div>{props.white ? <StarBorderWhiteIcon /> : <StarBorderBlackIcon />}</div>;
}

StarBorderIcon.propTypes = {
	white: PropTypes.bool,
};
